import React, { useState } from "react";
import { Popover } from "devextreme-react/popover";

const HelpToolTip = ({ id, message }) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisible = () => {
    if (id) {
      setIsVisible(!isVisible);
    }
  };
  return (
    <>
      <div
        style={{
          fontSize: "bold",
          cursor: "pointer",
          marginLeft: "5px",
        }}
      >
        <i
          id={id}
          className="dx-icon-help"
          onMouseEnter={toggleVisible}
          onMouseLeave={toggleVisible}
        ></i>
      </div>
      <Popover
        target={`#${id}`}
        position="right"
        width={300}
        visible={isVisible}
        animation={null}
      >
        {message ? message : ""}
      </Popover>
    </>
  );
};

export default HelpToolTip;
